<template>
  <div class="thousand_layout">
    <div class="right_box tab_width" v-if="list!=''">
      <div class="right_box_title">
        <h2>Saved Search</h2>
      </div>
      <list-pagination class="" />
    </div>
  </div>
</template>

<script>
/* 废页面 */


import ListPagination from '@/components/listpagination'
export default {
  name: 'tabslist',
  components: {ListPagination},
  data () {
    return {
      list:"",
    }
  },
  mounted() {
  },
  methods: {
  } 
} 
</script>

<style scoped>
@import "../../../static/css/usertabslist.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/search.vue